angular.module('bizmetryApp').controller('ResourcesTabController', function (
    $scope, $mdDialog, $mdToast, $timeout,
    ResourceService, ConfigurationService, dialogService, ProfileService
) {

    // ========================================
    // INICIALIZACIÓN
    // ========================================

    $scope.openResourceExplorer = function () {
        return $mdDialog.show({
            controller: 'ResourceExplorerDialogController', controllerAs: 'vm',
            templateUrl: 'profile/tabs/resources/resource-explorer/resource-explorer-dialog.html',
            parent: angular.element(document.body), multiple: true,
            clickOutsideToClose: false, escapeToClose: false,
            locals: { profile: $scope.profile, resourceTypeId: $scope.resource.selectedType }
        });
    };

    $scope.resourceTypes = [];
    $scope.loadingResources = false;
    $scope.loadingResourceTypes = false;
    $scope.filteredResources = [];

    $scope.resource = {
        totalItems: 0,
        page: 0,
        totalPages: 0,
        pageSize: 10,
        // central-config (bizmetry-shared): frontend.resources.page_size_options
        pageSizeOptions: ConfigurationService.getFromCache('frontend.resources.page_size_options')
            || [5, 10, 15, 25, 50, 100, 250, 500, 1024],
        searchDebounce: ConfigurationService.getFromCache('frontend.search_debounce_time') || 1000,
        sortOptions: [
            { value: 'name_asc',  label: 'Name (A-Z)'   },
            { value: 'name_desc', label: 'Name (Z-A)'   },
            { value: 'date_asc',  label: 'Oldest First' },
            { value: 'date_desc', label: 'Newest First' }
        ],
        selectedSort: 'name_asc',
        search: '',
        selectedType: 'ALL'
    };

    // ========================================
    // BULK SELECTION STATE
    // ========================================

    $scope.selectedResourceIds = new Set();

    // Contador reactivo — Angular no detecta mutaciones en Set,
    // pero sí detecta cambios en primitivos del $scope.
    // Referenciarlo en ng-checked fuerza re-evaluación en cada add/remove.
    $scope._selectedCount = 0;

    // selectionState: mapa id→boolean para los md-checkbox de la página actual
    $scope.selectionState = {};

    // ── Helpers de mutación (siempre usar estos, nunca .add/.delete directo) ──

    function addSelection(id) {
        if (!$scope.selectedResourceIds.has(id)) {
            $scope.selectedResourceIds.add(id);
            $scope._selectedCount++;
        }
    }

    function removeSelection(id) {
        if ($scope.selectedResourceIds.has(id)) {
            $scope.selectedResourceIds.delete(id);
            $scope._selectedCount--;
        }
    }

    // ── Sincroniza selectionState con el Set al cargar una página ──────────

    function syncSelectionStateToCurrentPage() {
        $scope.selectionState = {};
        ($scope.filteredResources || []).forEach(function (r) {
            $scope.selectionState[r.id] = $scope.selectedResourceIds.has(r.id);
        });
    }

    // ── Evaluadores de estado ───────────────────────────────────────────────

    function areAllCurrentPageSelected() {
        const page = $scope.filteredResources || [];
        return page.length > 0 && page.every(function (r) {
            return $scope.selectedResourceIds.has(r.id);
        });
    }

    $scope.areAllCurrentPageSelected = areAllCurrentPageSelected;

    $scope.isSomeCurrentPageSelected = function () {
        return ($scope.filteredResources || []).some(function (r) {
            return $scope.selectedResourceIds.has(r.id);
        });
    };

    $scope.isResourceSelected = function (resourceId) {
        return $scope.selectedResourceIds.has(resourceId);
    };

    $scope.getSelectedCount = function () {
        return $scope._selectedCount;
    };

    // ── Checkbox individual ─────────────────────────────────────────────────

    $scope.onResourceCheckboxChange = function (resourceId) {
        if ($scope.selectionState[resourceId]) {
            addSelection(resourceId);
        } else {
            removeSelection(resourceId);
        }
    };

    // ── Checkbox de cabecera (select-all / deselect-all de la página) ───────
    // Usa ng-checked="areAllCurrentPageSelected()" + ng-click en el HTML.
    // ng-checked no muta nada, así que al ejecutarse ng-click el estado
    // todavía refleja la situación real pre-click.

    $scope.onHeaderCheckboxClick = function () {
        const shouldSelectAll = !areAllCurrentPageSelected();

        ($scope.filteredResources || []).forEach(function (r) {
            if (shouldSelectAll) {
                addSelection(r.id);
                $scope.selectionState[r.id] = true;
            } else {
                removeSelection(r.id);
                $scope.selectionState[r.id] = false;
            }
        });
    };

    // ── Limpiar toda la selección ───────────────────────────────────────────

    $scope.clearSelection = function () {
        $scope.selectedResourceIds.clear();
        $scope._selectedCount = 0;
        $scope.selectionState = {};
    };

    // ========================================
    // BULK DELETE
    // ========================================

    $scope.bulkDeleteSelected = function () {
        const count = $scope._selectedCount;
        if (count === 0) return;

        dialogService.showDecisionDialog(
            'Confirm Bulk Delete',
            'Are you sure you want to permanently delete <b>' + count +
            ' resource' + (count !== 1 ? 's' : '') + '</b>?<br/><br/>' +
            'This action cannot be undone.'
        ).then(function (decision) {
            if (decision !== 'proceed') return;

            const ids = Array.from($scope.selectedResourceIds);

            ResourceService.bulkDeleteByIds($scope.profile.id, ids)
                .then(function (response) {
                    const deleted = response.data?.deleted || ids.length;

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(deleted + ' resource' + (deleted !== 1 ? 's' : '') + ' deleted successfully')
                            .position('top right')
                            .hideDelay(4000)
                    );

                    $scope.clearSelection();
                    $scope.loadResourceTypes();
                    $scope.loadResources();
                })
                .catch(function (error) {
                    console.error('[ResourcesTab] Bulk delete error:', error);
                    dialogService.showErrorDialog(
                        'Bulk Delete Failed',
                        error.data?.message || 'An unexpected error occurred during bulk deletion.'
                    );
                });
        });
    };

    // ========================================
    // DELETE ALL (every resource of the selected type, server-side)
    // ========================================

    $scope.deletingAllOfType = false;

    $scope.canDeleteAllOfType = function () {
        return !$scope.deletingAllOfType && !!$scope.resource.selectedType && $scope.resource.selectedType !== 'ALL';
    };

    $scope.deleteAllOfSelectedType = function () {
        if (!$scope.canDeleteAllOfType()) return;

        const typeId = $scope.resource.selectedType;
        const type = ($scope.resourceTypes || []).find(function (t) { return t.id === typeId; });
        const typeName = type ? type.name : 'the selected type';
        // totalItems is the type's count only when no name search narrows the list.
        const countText = !$scope.resource.search && $scope.resource.totalItems
            ? '<b>' + $scope.resource.totalItems + ' resource' + ($scope.resource.totalItems !== 1 ? 's' : '') + '</b>'
            : '<b>every resource</b>';

        dialogService.showDecisionDialog(
            'Delete All Resources of Type',
            '⚠️ <b>Warning:</b> this will permanently delete ' + countText + ' of type <b>' + typeName + '</b>' +
            ' in this profile, across all environments — not only the ones on this page or matching the search.' +
            '<br/><br/>Their stored source records are deleted too, and agents linked to this profile are notified.' +
            '<br/><br/>This action cannot be undone.'
        ).then(function (decision) {
            if (decision !== 'proceed') return;

            $scope.deletingAllOfType = true;
            ResourceService.deleteAllByType($scope.profile.id, typeId)
                .then(function (response) {
                    const deleted = response.data?.deletedCount ?? response.data?.deleted ?? 0;
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(deleted + ' resource' + (deleted !== 1 ? 's' : '') + ' of type ' + typeName + ' deleted')
                            .position('top right')
                            .hideDelay(4000)
                    );
                    $scope.clearSelection();
                    $scope.resource.selectedType = 'ALL';
                    $scope.resource.page = 0;
                    $scope.loadResourceTypes();
                    $scope.loadResources();
                })
                .catch(function (error) {
                    console.error('[ResourcesTab] Delete all of type error:', error);
                    dialogService.showErrorDialog(
                        'Delete All Failed',
                        error.data?.message || 'An unexpected error occurred while deleting the resources.'
                    );
                })
                .finally(function () {
                    $scope.deletingAllOfType = false;
                });
        });
    };

    // ========================================
    // CARGAR RESOURCE TYPES DESDE API
    // ========================================

    var resourceTypesSequence = 0;
    $scope.loadResourceTypes = function () {
        if (!$scope.profile || !$scope.profile.id) return;

        $scope.loadingResourceTypes = true;
        var id = $scope.profile.id, sequence = ++resourceTypesSequence;

        return ResourceService.getResourceTypesByProfile(id)
            .then(function (response) {
                if (disposed || sequence !== resourceTypesSequence || $scope.profile.id !== id) return;
                $scope.resourceTypes = response?.data?.resource_types || [];
                if ($scope.resource.selectedType !== 'ALL' && !$scope.resourceTypes.some(function (type) {
                    return type.id === $scope.resource.selectedType;
                })) {
                    $scope.resource.selectedType = 'ALL';
                    $scope.resource.page = 0;
                }
            })
            .catch(function (error) {
                if (disposed || sequence !== resourceTypesSequence || $scope.profile.id !== id) return;
                if (error && error.status === 204) {
                    $scope.resourceTypes = [];
                    $scope.resource.selectedType = 'ALL';
                    $scope.resource.page = 0;
                    return;
                }
                console.error('[ResourcesTab] Error loading resource types:', error);
                $scope.resourceFiltersError = 'Could not refresh resource types. Reopen this tab to retry.';
            })
            .finally(function () {
                if (!disposed && sequence === resourceTypesSequence) $scope.loadingResourceTypes = false;
            });
    };

    // ========================================
    // BÚSQUEDA CON DEBOUNCE
    // ========================================

    let resourceSearchTimeout;

    $scope.debouncedResourceSearch = function () {
        if (resourceSearchTimeout) {
            $timeout.cancel(resourceSearchTimeout);
        }
        resourceSearchTimeout = $timeout(function () {
            $scope.onResourceNavBarChange();
        }, $scope.resource.searchDebounce);
    };

    // ========================================
    // PAGINACIÓN
    // ========================================

    $scope.onResourcePageDown = function () {
        if ($scope.resource.page > 0) {
            $scope.resource.page--;
            $scope.loadResources();
        }
    };

    $scope.onResourcePageUp = function () {
        if ($scope.resource.page < $scope.resource.totalPages - 1) {
            $scope.resource.page++;
            $scope.loadResources();
        }
    };

    $scope.onResourcePageSizeChange = function () {
        $scope.resource.page = 0;
        $scope.loadResources();
    };

    // ========================================
    // CARGAR RESOURCES
    // ========================================

    $scope.loadResources = function () {
        $scope.loadingResources = true;

        const params = {
            page: $scope.resource.page,
            size: $scope.resource.pageSize,
            search: $scope.resource.search,
            resourceType: ($scope.resource.selectedType === 'ALL') ? '' : $scope.resource.selectedType,
            sort: $scope.resource.selectedSort
        };

        return ResourceService.listResourcesByProfile($scope.profile.id, params)
            .then(function (response) {
                const data = response?.data;
                $scope.filteredResources = data?.resources || [];
                // Highlight the term that produced these rows, not the one being typed.
                $scope.resource.highlightTerm = params.search || '';
                $scope.resource.totalPages = data?.totalPages || 0;
                $scope.resource.totalItems = data?.totalElements || 0;
                $scope.resource.page = data?.page || 0;

                if ($scope.resource.page >= $scope.resource.totalPages && $scope.resource.totalPages > 0) {
                    $scope.resource.page = $scope.resource.totalPages - 1;
                }

                syncSelectionStateToCurrentPage();
            })
            .catch(function (error) {
                console.error('Error loading resources:', error);
                $scope.filteredResources = [];
                syncSelectionStateToCurrentPage();
            })
            .finally(function () {
                $scope.loadingResources = false;
            });
    };

    // ========================================
    // CAMBIO DE FILTROS
    // ========================================

    $scope.onResourceNavBarChange = function () {
        $scope.resource.page = 0;
        $scope.loadResources();
    };

    $scope.updateResourceFilters = function () {
        $scope.loadResources();
    };

    // ========================================
    // CREAR RESOURCE
    // ========================================

    $scope.createNewResource = function () {
        $mdDialog.show({
            controller: 'ResourceCreateDialogController',
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'profile/tabs/resources/create-resources/resource-create-dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            multiple: true,
            escapeToClose: true,
            locals: {
                environments: $scope.profile?.environments || [],
                profile: $scope.profile
            }
        }).then(function (newResource) {
            if (newResource) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Resource created successfully!')
                        .position('top right')
                        .hideDelay(3000)
                );
                $scope.loadResourceTypes();
                $scope.onResourceNavBarChange();
            }
        }).catch(function (reason) {
            if (!reason || reason === 'user_cancelled' || reason === 'cancel') return;

            console.error('❌ Error in Create Resource dialog:', reason);

            var errorMessage = 'An error occurred while creating the resource.';
            if (reason && typeof reason === 'object') {
                if (reason.data && reason.data.message)  errorMessage = reason.data.message;
                else if (reason.message)                 errorMessage = reason.message;
                else if (reason.statusText)              errorMessage = reason.statusText;
            } else if (typeof reason === 'string') {
                errorMessage = reason;
            }

            dialogService.showErrorDialog('Error', errorMessage);
        });
    };

    // ========================================
    // EDITAR RESOURCE
    // ========================================

    $scope.openEditResourceDialog = function (resource) {
        $mdDialog.show({
            controller: 'EditResourceDialogController',
            controllerAs: 'vm',
            templateUrl: 'profile/tabs/resources/edit-resources/resource-edit-dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            multiple: true,
            locals: {
                resource: resource,
                profile: $scope.profile,
                environments: $scope.profile?.environments || []
            }
        }).then(function (updated) {
            if (updated) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Resource updated successfully')
                        .position('top right')
                        .hideDelay(3000)
                );
                $scope.loadResources();
            }
        });
    };

    // ========================================
    // TOGGLE ENABLE/DISABLE
    // ========================================

    $scope.onToggleResourceEnabled = function (resource) {
        var previousState = !!resource.isEnabled;

        ResourceService.patchResource($scope.profile.id, resource.id, { enabled: resource.enabled })
            .then(function () {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Resource status updated successfully')
                        .position('top right')
                        .hideDelay(3000)
                );
            })
            .catch(function (error) {
                console.error('Error updating resource status:', error);
                resource.isEnabled = previousState;
                dialogService.showErrorDialog(
                    'Error',
                    'There was an error updating the resource status. Detail = <' +
                    (error.data?.message || 'Unknown error') + '>'
                );
            });
    };

    // ========================================
    // ELIMINAR RESOURCE (doble clic)
    // ========================================

    $scope.confirmDeleteResourceMap = {};
    $scope.deleteResourceTimers = {};
    const RESOURCE_CONFIRM_TIMEOUT_MS = 3000;

    $scope.deleteResource = function (resource) {
        if (!$scope.confirmDeleteResourceMap[resource.id]) {
            $scope.confirmDeleteResourceMap[resource.id] = true;

            if ($scope.deleteResourceTimers[resource.id]) {
                $timeout.cancel($scope.deleteResourceTimers[resource.id]);
            }

            $scope.deleteResourceTimers[resource.id] = $timeout(function () {
                $scope.confirmDeleteResourceMap[resource.id] = false;
                delete $scope.deleteResourceTimers[resource.id];
            }, RESOURCE_CONFIRM_TIMEOUT_MS);

        } else {
            dialogService.showDecisionDialog(
                'Confirm Delete',
                'Are you sure you want to delete resource <b>' + resource.resourceName + '</b>?'
            ).then(function (decision) {
                if (decision === 'proceed') {
                    ResourceService.deleteResource($scope.profile.id, resource.id)
                        .then(function () {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent('Resource deleted successfully')
                                    .position('top right')
                                    .hideDelay(3000)
                            );
                            removeSelection(resource.id);
                            $scope.loadResourceTypes();
                            $scope.loadResources();
                        })
                        .catch(function (err) {
                            dialogService.showErrorDialog(
                                'Error Deleting Resource',
                                err.data?.message || 'Unknown error'
                            );
                        });
                }

                $scope.confirmDeleteResourceMap[resource.id] = false;
                if ($scope.deleteResourceTimers[resource.id]) {
                    $timeout.cancel($scope.deleteResourceTimers[resource.id]);
                    delete $scope.deleteResourceTimers[resource.id];
                }
            });
        }
    };

    $scope.getResourceDeleteTooltip = function (resource) {
        return $scope.confirmDeleteResourceMap[resource.id]
            ? 'Click again to confirm the deletion'
            : 'Delete resource';
    };

    // ========================================
    // IMPORTAR RESOURCES DESDE DB
    // ========================================

    $scope.importResourcesFromDb = function () {
        $mdDialog.show({
            controller: 'ImportResourceInstanceDialogController',
            controllerAs: 'vm',
            templateUrl: 'profile/tabs/resources/import-resources/import-resources-dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            multiple: true,
            locals: {
                resourceTypes: $scope.resourceTypes || [],
                environments: $scope.profile?.environments || [],
                profile: $scope.profile,
                templateInstance: $scope.template
            }
        }).then(function (importResult) {
            if (importResult && (importResult.created > 0 || importResult.updated > 0)) {
                var message = 'Successfully imported: ' +
                    importResult.created + ' created, ' +
                    importResult.updated + ' updated';

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(message)
                        .position('top right')
                        .hideDelay(4000)
                );
            }
            $scope.loadResourceTypes();
            $scope.loadResources();
        }).catch(function (error) {
            if (error !== 'user_cancelled' && error !== 'cancel') {
                console.error('[ResourcesTab] Import error:', error);
            }
        });
    };

    // ========================================
    // CLEANUP
    // ========================================

    $scope.$on('$destroy', function () {
        if (resourceSearchTimeout) {
            $timeout.cancel(resourceSearchTimeout);
        }
    });

    // ========================================
    // AUTO-LOAD
    // ========================================

    var filtersRefresh = null, filtersProfileId = null, refreshSequence = 0, disposed = false;

    function refreshResourceFilters() {
        if (disposed || !$scope.profile || !$scope.profile.id) return;
        var id = $scope.profile.id;
        if (filtersRefresh && filtersProfileId === id) return filtersRefresh;
        var sequence = ++refreshSequence;
        filtersProfileId = id;
        $scope.resourceFiltersError = '';
        // Refresh environment/template assignments too: import/create dialogs use them.
        filtersRefresh = ProfileService.getProfileById(id).then(function (response) {
            if (disposed || sequence !== refreshSequence || $scope.profile.id !== id) return;
            var fresh = response.data || {};
            $scope.profile.environments = fresh.environments || (fresh.profileData || {}).environments || [];
            return $scope.loadResourceTypes();
        }).then(function () {
            if (disposed || sequence !== refreshSequence || $scope.profile.id !== id) return;
            return $scope.loadResources();
        }).catch(function (error) {
            if (disposed || sequence !== refreshSequence) return;
            $scope.resourceFiltersError = 'Could not refresh resource filters. Reopen this tab to retry.';
            console.error('[ResourcesTab] Filter refresh failed:', error);
        }).finally(function () {
            if (sequence === refreshSequence) filtersRefresh = null;
        });
        return filtersRefresh;
    }

    // The parent broadcasts every tab activation. The initial timeout covers
    // lazy ng-if creation, which can happen after that broadcast was delivered.
    $scope.$on('profile:tabActivated', function (event, index) {
        if (index === 5) refreshResourceFilters();
    });
    $scope.$on('$destroy', function () { disposed = true; refreshSequence++; });
    $timeout(refreshResourceFilters, 0);
    $scope.$watch('profile.id', function (newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
            $scope.clearSelection();
            refreshResourceFilters();
        }
    });

});